import Axios, { AxiosInstance } from "axios";
import router from "@/router";
import Vue from "vue";
import authHeader, { usingCompanyId } from "@/common/qAuthHeader";
import store from "@/store/index";

export interface ApiResponse {
  meta: any;
  data: any;
}
let http = null;
class api {
  // public http: any;
  public loader: any;

  getHttp(): AxiosInstance {
    return http;
  }
  showLoading(response) {
    if (response.config && response.config.data && response.config.data instanceof FormData) {
      this.loader && this.loader.hide();
    } else if (response.config && response.config.data) {
      const configData = JSON.parse(response.config.data);
      this.loader && configData.notLoading === undefined && this.loader.hide();
    } else {
      this.loader && this.loader.hide();
    }
  }
  setup(): void {
    if (http) {
      return;
    }
    // set basic url or toket
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      baseURL: process.env.VUE_APP_API_URL,
    };

    http = Axios.create(config);
    http.interceptors.request.use(
      (config: any) => {
        const token = authHeader();
        const usingCompany = usingCompanyId();

        if (!(config.data && config.data.notLoading)) {
          this.loader && this.loader.hide();
          this.loader = Vue.$loading.show({});
        }

        if (token.Authorization) {
          config.headers = { ...config.headers, ...token };
        }
        if (usingCompany['Using-Company']) {
          config.headers = { ...config.headers, ...usingCompany };
        }
        return config;
      },
      (error: any) => {
        this.showLoading(error);
        // Do something with request error
        return Promise.resolve(error);
      }
    );
    http.interceptors.response.use(
      (response: any) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        this.showLoading(response);
        return response;
      },
      (error: any) => {
        this.showLoading(error);
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        let noRedirect = false;
        if (!(error.config.data instanceof FormData)) {
          noRedirect = error.config.data ? JSON.parse(error.config.data).noRedirect : false;
        }

        if (
          error.response.status === 401 &&
          router.currentRoute.name !== "login"
        ) {
          store.dispatch("Auth/logout");
          return Promise.reject(error.response);
        } else if (error.response.status === 404) {
          !noRedirect && router.push({ name: "not-found" });
          return Promise.resolve(error.response);
        } else if (error.response.status === 406) {
          // clear using company
          store.dispatch("Auth/setUsingCompany", null);
          !noRedirect && router.push({ name: "select-company" });
          return Promise.resolve(error.response);
        } else {
          return Promise.resolve(error.response);
        }
      }
    );
  }
}

export default api;
